export interface ForemanMaterialExpendable {
  foremanMaterialExpendableID: string;
  foremanJobID: string;
  dateWorked: Date;
  shift: number;
  foremanJobCrewID: string;
  description: string;
  quantity: number;
  totalPrice: number;
  bActive: boolean;
  unitCost?: number;
}
